import {Accordion, Icon} from "@chakra-ui/react"
import styled from "styled-components";
import {Header, RingEmpty, RingFull} from "../home-page/landing/landing.components";
import { MdKeyboardArrowDown } from "react-icons/md";
import {responsive} from "../../media-quries";
import {email} from "../../envs";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 80%;
  margin: auto;
  margin-top: 100px;
  position: relative;

  ${responsive.md`
  width: 90%;
  `}

  ${responsive.sm`
  width: 100%;
  `}
`;
const ItemTrigger = styled(Accordion.ItemTrigger)`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  text-align: left;
  
  .chakra-icon {
    transition: transform 0.2s;
  }
  
  &[data-state="open"] .chakra-icon {
    transform: rotate(180deg);
  }
`;
const Item = styled(Accordion.Item)`
  padding: 16px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #EEEEEEFF;
  }
`;
const Link = styled.a`
  color: #8e264b;
`;

const items = [
    {
        value: "1-item",
        title: "Jak działa wyszukiwanie numerów ksiąg wieczystych",
        content: "Nasz serwis umożliwia wyszukiwanie numerów ksiąg wieczystych dla działek, budynków, lokali, garaży oraz mieszkań, wykorzystując dane takie jak adres, identyfikator działki lub numer działki. Wyniki wyszukiwania prezentowane są w przejrzysty sposób, co ułatwia odnalezienie potrzebnych informacji."
    },
    {
        value: "2-item",
        title: "Czy serwis oferuje odkrycie numeru księgi wieczystej ale nie pozwala sprawdzić samej treści księgi wieczystej?",
        content: (
            <p>
                Serwis GeoKsiegi.pl oferuje możliwość odkrycia numeru księgi wieczystej. Wgląd w treść samej księgi umożliwia darmowy serwis{" "}
                <Link
                    href="https://przegladarka-ekw.ms.gov.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    przegladarka-ekw.ms.gov.pl
                </Link>. Aby przejrzeć treść księgi wieczystej należy znać uprzednio jej numer.
            </p>
        )
    },
    {
        value: "2a-item",
        title: "Dlaczego nie mogę znaleźć księgi wieczystej?",
        content: (
            <div>
                <p>Przyczyny mogą być różne – najczęściej:</p>
                <ul>
                    <li>- Niepełne lub błędne dane wpisane w księdze wieczystej.</li>
                    <li>- Nowo wybudowana nieruchomość, której księga wieczysta jeszcze nie istnieje.</li>
                    <li>- Dla danej nieruchomości księga wieczysta nie została założona lub nie została jeszcze przeniesiona do elektronicznych ksiąg wieczystych.</li>
                    <li>- Dane w elektronicznej księdze wieczystej nie zostały jeszcze zaktualizowane przez sąd który daną księgę obsługuje.</li>
                </ul>
            </div>
        )
    },
    {
        value: "2b-item",
        title: "Jak najlepiej odnaleźć księgę wieczystą?",
        content: "Dla lokali i budynków rekomendujemy wyszukiwanie po pełnym adresie (miejscowość, ulica, numer budynku). W przypadku działek najpewniejszą metodą jest wyszukiwanie po identyfikatorze"
    },
    {
        value: "2c-item",
        title: "Jaki jest czas realizacji usługi?",
        content: "Usługa odkrycia numeru księgi wieczystej jest realizowana automatycznie po udanym zakupie. Numer księgi zostaje wysyłany natychmiaastowo e-mailem. W razie braku wiadomości, prosimy o sprawdzenie folderu SPAM lub kontakt z nami. Dodatkowo jeśli mamy założone konto w serwisie, numer księgi wieczystej dostępny jest także w panelu użytkownika."
    },
    {
        value: "3-item",
        title: "Jakie metody płatności są dostępne?",
        content: "Płatności dokonywane są za pośrednictwem systemu Stripe. Akceptujemy płatności kartami oraz zgodne z systemem Przelewy24, w tym BLIK, oraz szybkie przelewy bankowe."
    },
    {
        value: "4-item",
        title: "Jak mogę korzystać z pakietów odkryć numerów ksiąg?",
        content: "Użytkownicy, którzy zarejestrują konto w serwisie, mają dostęp do specjalnych pakietów, które oferują korzystniejsze ceny przy większej liczbie wyszukiwań. Wykupione pakiety są ważne bezterminowo. Szczegóły dotyczące pakietów oraz ich cen znajdziesz w sekcji cennik."
    },
    {
        value: "5-item",
        title: "Co zrobić, gdy napotkam problem techniczny lub mam pytania?",
        content: (
            <p>
                W przypadku problemów technicznych lub pytań dotyczących działania serwisu, prosimy o kontakt na adres e-mail: <Link href={`mailto:${email}`}>{email}</Link>.
            </p>
        )
    }
];
const Ring1 = styled(RingEmpty)`
  width: 120px;
  height: 120px;
  top: 0;
  left: -50px;
`;
const Ring2 = styled(RingEmpty)`
  width: 150px;
  height: 150px;
  bottom: -20px;
  right: -40px;

  ${responsive.sm`
    display: none;
  `}
`;
const Ring3 = styled(RingFull)`
  width: 40px;
  height: 40px;
  top: 110px;
  left: -60px;
`;

function Faq() {
    return <Container>
        <Header>FAQ - Najczęściej zadawane pytania</Header>
        <Accordion.Root collapsible>
            {items.map((item, index) => (
                <Item key={item.value} value={item.value}>
                    <ItemTrigger>
                        <Icon fontSize="lg" color="fg.subtle">
                            <MdKeyboardArrowDown size={24} />
                        </Icon>
                        {item.title}
                    </ItemTrigger>
                    <Accordion.ItemContent>
                        <Accordion.ItemBody>{item.content}</Accordion.ItemBody>
                    </Accordion.ItemContent>
                </Item>
            ))}
        </Accordion.Root>
        <Ring1 />
        <Ring2 />
        <Ring3 />
    </Container>
}

export default Faq
